<template>
  <div>
    <h2 class="font_size_1000rem font_weight_bold mb-4">{{ titleText }}</h2>
    <b-row v-if="!questionnaires || questionnaires.length === 0">
      <b-col cols="12" class="text-center pt-1 pb-4">
        {{ emptyListMessage }}
      </b-col>
    </b-row>
    <template v-else>
      <div v-for="questionnaire in questionnaires" :key="questionnaire.id">
        <questionnaire-item
          :questionnaire="questionnaire"
          class="mb-2"
          @reseted-study="$emit('reseted-study')"
          @fill-user-profile="$emit('fill-user-profile', $event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import QuestionnaireItem from '@/components/questionnaire/QuestionnaireItem';

export default {
  name: 'QuestionnairesList',
  components: {
    QuestionnaireItem,
  },
  props: {
    questionnaires: {
      required: true,
      type: Array,
    },
    titleText: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    emptyListMessage: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables_mixins.scss';
.phairify-q-box {
  padding: 5px 10px 0 10px;
  border: 2px solid rgba($phairify_secondary_color_grey, 0.25);
}

.phairify-q-box-header {
  border: none;
}

.phairify-q-box-title {
  @include phairify_heading_bold_18;
}

.phairify-q-box-body {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
